/* import __COLOCATED_TEMPLATE__ from './deleted-at-with-tooltip.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();